import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import PortalLayout from "@/components/layout/PortalLayout";
import ErrorBoundary from "@/components/ErrorBoundary";

export default function PortalRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex items-center gap-3 text-muted-foreground">
          <div className="w-4 h-4 border-2 border-teal border-t-transparent rounded-full animate-spin" />
          <span className="text-sm">Loading client portal…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "client") return <Navigate to="/" replace />;
  return <PortalLayout><ErrorBoundary key={location.pathname}>{children}</ErrorBoundary></PortalLayout>;
}
